module.exports = __webpack_public_path__ + "img/ward_dispenser_sentry.96a52c71.png";